<template>
	<div class="wrap">
		<h1>Страница находится в разработке</h1>
		<h3>Отсутсвуют данные для загрузки</h3>
		<hr>
		<div class="wrap">
			<b-img src="src/assets/razrabotka.jpg" fluid/>
		</div>
	</div>
</template>
<script>
	export default{

	};
</script>
<style scoped>
	.wrap{
		padding: 10px;
	}
		h1, h3{
			text-align: center;
		}


	@media(max-width: 768px){
		h1, h3{
			font-size: 1.5rem;
			text-align: center;
		}
		
	}
</style>